import { Injectable, inject } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class NavigationTrackerService {
  private readonly router = inject(Router);
  private previousUrl = '/home';

  constructor() {
    this.router.events
      .pipe(filter((event): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event) => {
        const url = event.urlAfterRedirects || event.url;
        // Don't save auth routes as the previous non-auth page.
        if (url && !url.includes('/auth/')) {
          this.previousUrl = url;
        }
      });
  }

  getPreviousUrl(): string {
    return this.previousUrl;
  }
}
